import React, { Component } from "react";
import { observer } from "mobx-react";

import { StreamType } from "@formant/core/model/StreamType";

import { StreamFilter } from "../../store/IStreamStore";
import { streamStore } from "../../stores";
import { MultiSelect } from "../common/MultiSelect";
import { streamTypeIcons } from "../common/StreamIcon";

export interface IStreamTypeSelectProps {
    streamFilter: StreamFilter;
    value: StreamType[];
    className?: string;
    onChange: (value: StreamType[]) => void;
}

@observer
export class StreamTypeSelect extends Component<IStreamTypeSelectProps> {
    private streamTypes: StreamType[] = [];
    public render() {
        const { streamFilter, value, className, onChange } = this.props;
        this.streamTypes =
            streamStore.getStreamTypes(streamFilter) || this.streamTypes;
        const streamTypes = this.streamTypes;
        const options = streamTypes.sort().map(type => ({
            value: type,
            icon: streamTypeIcons[type],
        }));
        if (options.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && options.length === 1;
        return (
            <MultiSelect
                value={value}
                title="Stream type"
                options={options}
                className={className}
                onChange={onChange}
                disabled={disabled}
            />
        );
    }
}
